import Button from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';
import Grid from 'material-ui/Grid';
import Typography from 'material-ui/Typography';
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import parser from 'parse-address';
import {
  countries,
  DropDownMenu,
  required,
  TextField,
  dob,
  kycStatuses,
} from 'entoro-shared';
import {
  PhoneNumberInput,
  validatePhone,
} from '../../../FormFields/PhoneNumberInput';
import { CONTACT_EMAIL_DEFAULT } from '../../../../config';

const number = (value) =>
  value && isNaN(Number(value)) ? 'Must be a number' : undefined;
const minValue = (min) => (value) =>
  value && value.length < min ? `Must be ${min} characters` : undefined;
const minValue3 = minValue(4);
const maxInput = (max) => (value) => {
  let v;
  let result = value.length > max;

  if (result === false) {
    v = value;
  }
  return v;
};

const InvestorKycForm = reduxForm({
  form: 'investorKycForm',
  enableReinitialize: true,
})(
  ({
    handleSubmit,
    submitting,
    request,
    title,
    handleClose,
    submitText,
    kycStatus,
  }) => (
    <form onSubmit={handleSubmit(request)}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          <b>{`Current Status: ${kycStatuses.getLabel(kycStatus)}`}</b>
          <br />
          <br />
          {
            'In order to continue the investment process, we require a background check as part of the screening process.'
          }
          <br />
          <br />
          <i>
            If you have any questions about verification or need assistance
            getting verified, please contact{' '}
            <a href={`mailto:${CONTACT_EMAIL_DEFAULT}`}>
              {CONTACT_EMAIL_DEFAULT}
            </a>
            .
          </i>
          <br />
        </DialogContentText>
        <br />
        <Grid container>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={TextField}
              validate={[required]}
              name='firstName'
              label='First Name'
              autoComplete='given-name'
              required
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={TextField}
              validate={[required]}
              name='lastName'
              label='Last Name'
              autoComplete='family-name'
              required
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={TextField}
              name='email'
              label='Email'
              type='email'
              disabled
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={TextField}
              validate={[required, dob]}
              name='dob'
              label='Date of Birth'
              required
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={PhoneNumberInput}
              validate={[required, validatePhone]}
              name='officePhoneNumber'
              label='Office Phone Number'
              required
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={PhoneNumberInput}
              validate={[validatePhone]}
              name='mobilePhoneNumber'
              label='Mobile Phone Number'
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <Typography type='subheading'>Location</Typography>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={DropDownMenu}
              validate={[required]}
              name='country'
              label='Country'
              options={countries.options}
              helperText=''
              required
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={TextField}
              validate={[required]}
              name='street'
              label='Street'
              required
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={TextField}
              validate={[required]}
              name='zip'
              label='Zip'
              required
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={TextField}
              validate={[required]}
              name='city'
              label='City'
              required
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={TextField}
              validate={[required]}
              name='state'
              label='State'
              required
            />
            <br />
            <br />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Field
              component={TextField}
              validate={[required, number, minValue3]}
              name='nationalIdMasked'
              label=' SSN last four digits'
              required
              normalize={maxInput(4)}
            />
            <br />
            <br />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button
          disabled={submitting}
          onClick={handleClose}
          className='action-button cancel'
          disableRipple
        >
          Cancel
        </Button>
        <Button
          type='submit'
          disabled={submitting}
          className='action-button'
          disableRipple
        >
          {submitting ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <CircularProgress size={15} color='inherit' />
              &nbsp;
              {submitText}
            </div>
          ) : (
            submitText
          )}
        </Button>
      </DialogActions>
    </form>
  )
);

const mapStateToProps = ({ investorUser = {} }, { offerId }) => {
  const {
    kycStatus,
    firstName,
    lastName,
    email,
    officePhoneNumber,
    mobilePhoneNumber,
    country,
    address,
  } = investorUser;
  const {
    number = '',
    prefix = '',
    street = '',
    type = '',
    zip = '',
    city = '',
    state = '',
  } = parser.parseLocation(address);
  const parsedStreet = `${number} ${prefix} ${street} ${type}`
    .replace(/\s+/g, ' ')
    .trim();

  return {
    kycStatus,
    initialValues: {
      offerId,
      firstName,
      lastName,
      email,
      officePhoneNumber,
      mobilePhoneNumber,
      country: country || 'US',
      street: parsedStreet,
      zip,
      city,
      state,
    },
  };
};

export default connect(mapStateToProps)(InvestorKycForm);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/InvestorKyc/InvestorKycForm.js